
  import createMeisterIcons from '../src/createMeisterIcons';

  const Lock = createMeisterIcons("lock", [["path",{"fill":"currentColor","d":"M8.75 7A3.26 3.26 0 0 1 12 3.75c.872 0 1.688.399 2.27.98.581.582.98 1.398.98 2.27v2.082A6.7 6.7 0 0 0 12 8.25a6.7 6.7 0 0 0-3.25.832zm-1.5 3.204V7A4.76 4.76 0 0 1 12 2.25c1.328 0 2.512.601 3.33 1.42.819.818 1.42 2.002 1.42 3.33v3.204a6.75 6.75 0 1 1-9.5 0M6.75 15a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0","key":"14e80986c517f99a2d2a5339fbfba6365d2948ce","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Lock
  